// import {yandexMapService} from '@/_services/yandexMap.service'

export default {
  namespaced: true, 

  state: {
    listGeoData: {"point": [{"id": "1001","title": "ТРЦ «Керуен»","lon": "71.437292","lat": "51.156608","type": "Торговый центр","info": "г. Астана, ул. Достык, д. 9<br>Режим работы:<br>Ежедневно: 10:00 - 22:00<br>Популярное место для шопинга и отдыха в центре левобережья.","maplayer_id": 1,"ptype": 1,"features": "","foto": "","url": ""},{"id": "1002","title": "Бизнес-центр «Talan Towers»","lon": "71.420700","lat": "51.117454","type": "Бизнес-центр","info": "г. Астана, ул. Достык, д. 16<br>Обслуживание юридических и физических лиц.<br>Современный комплекс класса А+ возле Байтерека.","maplayer_id": 1,"ptype": 1,"features": "","foto": "","url": ""},{"id": "1003","title": "ЖК «Гранд Астана»","lon": "71.421545","lat": "51.167295","type": "Жилой комплекс","info": "г. Астана, пр. Тауелсиздик, д. 34<br>Дополнительный пункт обслуживания.<br>Расположен в районе площади Независимости и мечети Хазрет Султан.","maplayer_id": 1,"ptype": 1,"features": "","foto": "","url": ""}]
}
  },

  mutations: {
    setListGeoData(state, payload) {
      state.listGeoData = payload
    },
  },
  
  actions: {
    loadListGeoData({commit}) {
      commit
      return true
      // return yandexMapService.getListGeoData().then(data =>  {
      //   commit('setListGeoData', data)
      // })
    },
  }

}